import { useEffect } from 'react';
import { events } from '@ux/header-util';

/**
 * A simple pub-sub style subscribe to a topic
 *
 * @param {Function} callback - the callback function
 * @param {String} topic - the identifier that will trigger the callback
 */
export const useSubscribe = (callback, topic) => {
  useEffect(() => {
    events.on(topic, callback);
    // console.log(`Subscribed to ${topic}, callback:`, callback);
    return () => {
      // console.log(`Unsubscribing from topic: ${topic} callback:`, callback);
      events.off(topic, callback);
    };
  }, [callback, topic]);

};

export const publish = events.emit.bind(events);

/**
 * Just a hooksy way to get the publish, eventually may be context aware
 */
export const usePublish = () => {
  return publish;
};
